import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HospitalSettlemedLogo from "../../assets/HospitalSettlemedLogo.svg";
import HospitalSettlemedText from "../../assets/HospitalSettlemedName.svg";
import RotatedArrow from "../../assets/rotatedArrow.svg";
import CaseMappingIcon from "../../assets/caseMappingIcon.svg";
import SearchIcon from "../../assets/searchIcon.svg";
import HospitalCallIcon from "../../assets/hospitalCallIcon.svg";
import doubleChatIcon from "../../assets/doubleChatIcon.svg";
import newNotificationIcon from "../../assets/newNotificationIcon.svg";
import HospitalBellIcon from "../../assets/hospitalBellIcon.svg";
import MaleProfileIcon from "../../assets/maleProfileIcon.svg";
import DownArrow from "../../assets/downArrowWhite.svg";
import upwardArrow from "../../assets/upwardArrow.svg";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { logOut, getUser } from "../../config/user";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { RpaServices } from "../../services/RpaServices";
import { useDispatch } from "react-redux";
import {
  setNewCaseAddRequest,
  setSearchKey,
} from "../../redux/caseDetailsSlice";
import SessionManagementModal from "./SessionManagementModal";

const Header = () => {
  const [expandProfile, setExpandProfile] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false); // State for session modal
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const user = getUser();
  const { notificationCount, newCommentCount } = useSelector(
    (store) => store.notificationReducer,
  );
  const { newCaseAddRequest, searchKey } = useSelector(
    (store) => store.caseDetails,
  );
  const dispatch = useDispatch();
  const searchTimeRef = useRef();

  const handleNewCaseMapping = async () => {
    try {
      const res = await RpaServices.checkNewCaseAdded(user?.hospital?.id);
      if (res?.data?.total === 0) {
        const data = { hospitalId: user?.hospital?.id, caseStatus: "NEW_CASE" };
        await RpaServices.addRpaRequest(data);
        dispatch(setNewCaseAddRequest(true));
        window.alert(
          "The Case is currently in progress and will appear in the list soon",
        );
      } else {
        window.alert(
          "A case is already in progress. Please wait before adding a new case.",
        );
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const checkCaseAddRequestPending = async () => {
    const res = await RpaServices.checkNewCaseAdded(user?.hospital?.id);
    if (res?.data?.total === 0) {
      dispatch(setNewCaseAddRequest(false));
    } else {
      dispatch(setNewCaseAddRequest(true));
    }
  };

  useEffect(() => {
    checkCaseAddRequestPending();
    dispatch(setSearchKey(""));
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;

    setSearchValue(value);

    if (searchTimeRef.current) {
      clearTimeout(searchTimeRef.current);
    }

    searchTimeRef.current = setTimeout(() => {
      dispatch(setSearchKey(value.trim()));
    }, 500);
  };

  return (
    <div className="font-lufga flex justify-between items-center box-border">
      <div className="flex gap-1 items-center">
        <div onClick={() => navigate("/")}>
          <img src={HospitalSettlemedLogo} alt="logo" height={32} width={32} />
        </div>
        <div onClick={() => navigate("/")}>
          <img
            src={HospitalSettlemedText}
            alt="settlemed-text"
            height={32}
            width={112}
          />
        </div>
        <div className="font-inter font-normal text-[14px] leading-[100%] tracking-[-0.07em] text-[#00000099] whitespace-nowrap">
          No Claim Payment Left Behind
        </div>
        {/* <div className="xl:ml-[30px] 2xl:ml-[36px] 3xl:ml-[320px]">
          <div className="flex items-center gap-[10px] xl:w-[280px] 2xl:w-[340px] 3xl:w-[400px] h-[42px] px-[16px] bg-[#FFFFFF99] border border-solid border-[#FFFFFF] rounded-[52px]">
            <input
              type="text"
              value={searchValue}
              placeholder="Search anything"
              onChange={handleSearch}
              className="flex-1 bg-transparent outline-none border-none font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.05em] text-[#000000] placeholder:text-[#00000080]"
            />
            <img
              src={SearchIcon}
              alt="search-icon"
              className="w-[18px] h-[18px] flex-shrink-0 cursor-pointer"
            />
          </div>
        </div> */}
      </div>
      <div className="flex gap-[18px] 2xl:gap-[25px] items-center">
        {/* <div className="xl:ml-[24px] 2xl:ml-[32px] 3xl:ml-[40px] flex items-center justify-center gap-[10px] xl:w-[160px] 2xl:w-[176px] 3xl:w-[193px] xl:h-[42px] 2xl:h-[46px] 3xl:h-[53px] px-[20px] bg-[#FFFFFF99] border border-solid border-[#017C71] xl:rounded-[35px] 2xl:rounded-[60px] 3xl:rounded-[100px] cursor-pointer">
          <span className="font-lufga font-normal text-[12px] xl:leading-[12px] 2xl:leading-[100%] 3xl:leading-[100%] xl:tracking-[0px] 2xl:tracking-[-0.02em] 3xl:tracking-[-0.03em] text-[#000000] uppercase whitespace-nowrap">
            Create Abha
          </span>
          <img
            src={upwardArrow}
            alt="upward-arrow"
            className="w-[12px] h-[12px] flex-shrink-0"
          />
        </div> */}
        {/* <div className="xl:ml-[30px] 2xl:ml-[36px] 3xl:ml-[320px]"> */}
        <div>
          <div className="flex items-center gap-[10px] xl:w-[280px] 2xl:w-[340px] 3xl:w-[400px] h-[42px] px-[16px] bg-[#FFFFFF99] border border-solid border-[#FFFFFF] rounded-[52px]">
            <input
              type="text"
              value={searchValue}
              placeholder="Search anything"
              onChange={handleSearch}
              className="flex-1 bg-transparent outline-none border-none font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.05em] text-[#000000] placeholder:text-[#00000080]"
            />
            <img
              src={SearchIcon}
              alt="search-icon"
              className="w-[18px] h-[18px] flex-shrink-0 cursor-pointer"
            />
          </div>
        </div>
        {user?.hospital?.status === "ACTIVE" && (
          <div
            style={{
              border: "1px solid #017C71",
              background: "rgba(255,255,255,0.5)",
            }}
            className=" flex items-center justify-center gap-[10px] xl:w-[160px] 2xl:w-[176px] 3xl:w-[193px] xl:h-[42px] 2xl:h-[46px] 3xl:h-[53px] px-[20px] rounded-full cursor-pointer"
            onClick={handleNewCaseMapping}
          >
            <span className="font-lufga font-normal text-[12px] uppercase whitespace-nowrap">
              New Case Mapping
            </span>

            <img
              src={CaseMappingIcon}
              alt="case-mapping"
              className={`${newCaseAddRequest ? "animate-spin" : ""} w-[18px] h-[18px]`}
            />
          </div>
        )}
        {user?.hospital?.status === "ACTIVE" && (
          <div>
            <div
              className="relative flex items-center justify-center w-[48px] h-[48px] bg-[#FFFFFF80] border border-solid border-[#FFFFFF] rounded-[51px] cursor-pointer"
              onClick={() => navigate("/dashboard/comment-notifications")}
            >
              <img
                src={doubleChatIcon}
                alt="double-chat-icon"
                className="w-[20px] h-[15.85px]"
              />

              {newCommentCount > 0 && (
                <div className="absolute w-[25px] h-[25px] flex items-center justify-center -top-1 -right-2 bg-[#F04438] rounded-full font-lufga font-medium text-[10px] leading-[100%] text-white">
                  {newCommentCount > 999 ? "999+" : newCommentCount}
                </div>
              )}
            </div>
          </div>
        )}
        {user?.hospital?.status === "ACTIVE" && (
          <div>
            <div
              className="relative flex items-center justify-center w-[48px] h-[48px] bg-[#FFFFFF80] border border-solid border-[#FFFFFF] rounded-[51px] cursor-pointer"
              onClick={() => navigate("/dashboard/notifications")}
            >
              <img
                src={newNotificationIcon}
                alt="notification-icon"
                className="w-[14px] h-[14px]"
              />

              <div className="absolute w-[25px] h-[25px] flex items-center justify-center -top-1 -right-2 bg-[#F04438] rounded-full font-lufga font-medium text-[10px] leading-[100%] text-white">
                {notificationCount > 999 ? "999+" : notificationCount}
              </div>
            </div>
          </div>
        )}
        {user?.hospital && (
          <div
            className={`relative  bg-[#1B1B1B] px-[4px] py-[2px] ${
              expandProfile ? "rounded-t-[24px]" : "rounded-full"
            } cursor-pointer box-border`}
          >
            <div
              className="flex items-center"
              onClick={() => setExpandProfile(!expandProfile)}
            >
              <div className="flex items-center justify-center w-[34px] h-[34px] min-w-[38px] min-h-[38px] p-[6px] bg-white rounded-full border border-white flex-shrink-0">
                <img
                  src={MaleProfileIcon}
                  alt="profile-icon"
                  className="w-[28px] h-[28px] object-contain"
                />
              </div>
              {user?.hospital && (
                <div className="ml-[3px] text-white">
                  <div className="font-lufga font-normal text-[11px] 2xl:text-[12px] leading-[13px] tracking-[-0.4px] uppercase">
                    {user?.user?.fullName}
                  </div>{" "}
                  <div className="font-lufga font-light text-[9px] 2xl:text-[10px] leading-[12px]">
                    {user?.roles[0]?.role?.roleName}
                  </div>
                  <div className="font-lufga font-light text-[7px] 2xl:text-[8px] leading-[10px]">
                    ({user?.hospital?.name})
                  </div>
                </div>
              )}
              <div
                className="ml-[2px] mr-[3px] flex items-center justify-center"
                onClick={() => setExpandProfile(!expandProfile)}
              >
                <img
                  src={DownArrow}
                  alt="down-arrow"
                  className={`w-[13px] h-[8px] transition-all duration-300 ease-in-out ${
                    expandProfile ? "rotate-180" : "rotate-0"
                  }`}
                />
              </div>
            </div>
            <div
              className={`absolute top-full left-0 z-[30] w-full bg-[#1B1B1B] py-[5px] px-1 rounded-b-[27px] box-border transition-all duration-300 ease-in-out ${
                expandProfile
                  ? "max-h-[200px] opacity-100"
                  : "max-h-0 opacity-0"
              } overflow-hidden`}
            >
              <div
                className="text-xs text-center leading-[15.66px] -tracking-[3%] bg-white text-black px-5 py-[18.5px] rounded-full mt-[5px]"
                onClick={() => {
                  logOut();
                }}
              >
                LOGOUT
              </div>
              <div
                className="text-xs text-center leading-[15.66px] -tracking-[3%] bg-white text-black px-5 py-[18.5px] rounded-full mt-[5px]"
                onClick={() => {
                  setShowSessionModal(true);
                  setExpandProfile(false); // Close the profile dropdown
                }}
              >
                LOGGEDIN SESSIONS
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Session Management Modal */}
      {showSessionModal && (
        <SessionManagementModal
          visible={showSessionModal}
          onClose={() => setShowSessionModal(false)}
        />
      )}
    </div>
  );
};

export default Header;
